module.exports = __webpack_public_path__ + "img/ttncreateapp2.5910c7df.png";